var _circle, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SwitchOffAfterUse50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 11,
    x: 19.977,
    y: 11,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.285,10h-8.571C19.767,10,19,10.768,19,11.714v12.633C19.634,24.123,20.307,24,21,24V12h8v20 h-2.347c-0.259,0.732-0.659,1.409-1.19,2h3.823C30.233,34,31,33.232,31,32.286V11.714C31,10.768,30.232,10,29.285,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.805,27.172c-1.561-1.563-4.096-1.563-5.656,0l-7.422,7.422c1.692,2.116,3.876,3.816,6.38,4.932 l6.698-6.698C25.367,31.267,25.367,28.733,23.805,27.172z M22.391,31.414L20.805,33l-2.828-2.828l1.586-1.586 c0.781-0.781,2.047-0.781,2.828,0S23.172,30.633,22.391,31.414z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SwitchOffAfterUse50);
export default __webpack_public_path__ + "static/media/icons8-switch-off-after-use-50.e3dcf1d9d4b7c0fc964c73c98f798868.svg";
export { ForwardRef as ReactComponent };